import { Col, Form, Modal, Row, Typography } from "antd";
import GeneralPhoneNumber2 from "apps/Common/GeneralPhoneNumber2";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import useMazakaForm from "hooks/useMazakaForm";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RootState } from "store/Reducers";
import ConfirmLoginCode from "../../ConfirmCode/ConfirmCode";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { createStore, editStore } from "../Services";
import { handleSetUserInfoes } from "apps/CustomerPanel/Profile/ClientSideStates";
import { getSMSVerifyCode } from "apps/Account/Services";
import CountryAdressDetails from "apps/Common/Adress/CountryAddressDetails";
import { getUserInfoesByPhoneNumber } from "apps/Account/Services";
import {
  handleSetDoneSteps,
  handleSetinstitutionalStoreInfoes,
} from "../ClientSideStates";
import { getStoreDetails } from "apps/CustomerPanel/Store/Services";
import endPoints from "apps/CustomerPanel/Store/EndPoints";
import { useQueryClient } from 'react-query';
import { registerUser } from "apps/Account/Services";

const CorporateInfoes = (props: any) => {
  const [form] = Form.useForm();
  const [isFindUser, setIsFindUser] = useState(false);
  const [isLoadingFindUser, setIsLoadingFindUser] = useState(false);
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const storeId = searchParams.get("storeId");
  const { formActions, mazakaForm } = useMazakaForm(form);
  const [isShowConfirmCode, setIsShowConfirmCode] = useState(false);
  const [storeData, setStoreData] = useState<any>(null);
  const dispatch = useDispatch();
  const { initialStoreInfoes, email } = useSelector(
    (state: RootState) => state.institutional
  );
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const { tempFormData } = useSelector((state: RootState) => state.institutional);

    let newUser: any;
  useEffect(() => {
     //name: initialStoreInfoes?.isletmeAdSoyad || null,
    form.setFieldsValue({
      storeName: initialStoreInfoes?.isletmeUnvani || null,
      kepAddress: initialStoreInfoes?.isletmeAdresi || null,
    });
  }, [initialStoreInfoes]);

  const getStoreInfoes = async (storeId: string) => {
    try {
      const response = await getStoreDetails(storeId);
      if (response?.data) {
        let data = response?.data;
        if (!initialStoreInfoes) {
          form.setFieldsValue({
            ...data,
          });
        }
        setStoreData({ ...data });
      }
    } catch (error: any) {
      openNotificationWithIcon("default", error?.message);
      console.log("Somethings wrong during getting store", error);
    }
  };
  useEffect(() => {
    if (storeId) {
      getStoreInfoes(storeId);
    }
  }, [storeId]);

  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    if (storeId) {
      handleAfterConfirmPhone(userInfoes);
    } else {
      try {
        let formValues = form.getFieldsValue();
        let split_number = formValues["Phone"].split("+");
        let numberPrefix = split_number[0];
        let numberBody = split_number[1];
        const response = await getSMSVerifyCode(numberPrefix, numberBody);

        mazakaForm.setSuccess(1000, () => response.message || "Kod Gönderildi");
          const userResponse = await registerUser(tempFormData);

     newUser = userResponse.data; // id, email vs.
        setIsShowConfirmCode(true);
      } catch (error: any) {
        mazakaForm.setFailed(2000, error?.message);
        openNotificationWithIcon("default", error?.message);

        console.log("Somethings wrong during login to dashboard", error);
      }
    }
  };

 const handleAfterConfirmPhone = async (userInfoes:any) => {
  setIsShowConfirmCode(false);
  mazakaForm.setLoading();
  let formValues = form.getFieldsValue();

  try {
    // ✅ Önce User'ı Kaydet
  

    // ✅ Formdaki telefon numarasını parçala
    let split_number = formValues["Phone"].split("+");
    let numberPrefix = split_number[0];
    let numberBody = split_number[1];

    // ✅ Store create datasını hazırla
    const storeCreateData = {
      ...formValues,
      numberPrefix,
      numberBody,
      userId: userInfoes.id, 
      userType: 2,
      employeeCount: Number(formValues["employeeCount"]),
    };

    delete storeCreateData["Phone"];

    // ✅ Şimdi Store Kaydet
    const storeResponse = await createStore(storeCreateData);

    mazakaForm.setSuccess(1000, () => "Kayıt işlemi başarılı");
    openNotificationWithIcon("default", storeResponse.message || "");

    // ✅ Redux güncellemeleri
    dispatch(handleSetUserInfoes({ data: newUser }));
    form.resetFields();
    dispatch(handleSetDoneSteps({ data: [] }));

    navigate("/admin/panel");
  } catch (error: any) {
    mazakaForm.setFailed(2000, error?.message || "Bilinmeyen hata");
    openNotificationWithIcon("default", error?.message || "");
    console.log("User + Store kaydında hata", error);
  }
};


  const { Text } = Typography;
  const navigate = useNavigate();


  return (
    <>
      <Col span={24} className="!h-screen !overflow-scroll">
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          onFinish={handleOnFinish}
        >
          <Col span={24} className="!bg-[#e0f2f0] !p-2 !rounded-md">
            <Text className="!text-[#0DAA89]">
              TTBS No ile elde edilen bilgilere göre içeriklerin bazıları
              doldurulmuştur.
            </Text>
          </Col>
          <Row gutter={[10, 10]} className="!px-4">
            {!storeId && (
              <>
                <MazakaInput
                  xs={24}
                  lg={storeId ? 12 : 8}
                  name={"name"}
                  label={"Adı"}
                  className="!m-0"
                  inputClassName=" !p-2"
                  placeholder={"Adı"}
                  rules={[{ required: true, message: "" }]}
                />

                <MazakaInput
                  xs={24}
                  lg={storeId ? 12 : 8}
                  name={"surname"}
                  label={"Soyadı"}
                  className="!m-0"
                  inputClassName=" !p-2"
                  placeholder={"Soyadı"}
                  rules={[{ required: true, message: "" }]}
                />
              </>
            )}
            {props?.type !== "panelStore" && (
              <Col 
              xs={24}
              lg={8}
              >
                <Row>
                <GeneralPhoneNumber2
                  label={"Telefon Numarası"}
                  name="Phone"
                  required={true}
                    setInitialDataWithPhone={false}
                    isExistingUser={true}
                                  setIsExternalLading={setIsLoadingFindUser}
                                  setInitialDataWithPhoneService={getUserInfoesByPhoneNumber}
                                  setIsFindUser={setIsFindUser}
                                  disabled={isLoadingFindUser}
                                  loading={isLoadingFindUser}
                 xs={24}
                  form={form}
                  placeholder={"Telefon Numarası"}
                  inputClass="!m-0 !h-[39px] !text-black"
                  rules={[
                    {
                      required: true,
                      message: "",
                    },
                  ]}
                />
                {
                  isFindUser&&
                  <Col xs={24} >
                      <Text className="!text-red-500" >Bu telefon numarasına ait bir kullanıcı zaten kayıtlı.</Text>
                  </Col>
                }

                </Row>
              </Col>
            )}

            <MazakaInput
              xs={24}
              lg={6}
              name={"storeName"}
              disabled
              label={"Firma Adı"}
              className="!m-0"
              inputClassName=" !p-2"
              placeholder={"Firma Adı"}
              rules={[{ required: true, message: "" }]}
            />
            <MazakaInput
              xs={24}
              lg={6}
              name={"taxOffice"}
              label={"Vergi Dairesi"}
              className="!m-0"
              inputClassName=" !p-2"
              placeholder={"Vergi Dairesi"}
              rules={[{ required: true, message: "" }]}
            />
            <MazakaInput
              xs={24}
              lg={6}
              name={"taxNumber"}
              label={"Vergi Numarası"}
              type="number"
              className="!m-0"
              inputClassName=" !p-2"
              placeholder={"Vergi Numarası"}
              rules={[{ required: true, message: "" }]}
            />
            <MazakaInput
              xs={24}
              lg={6}
              name={"employeeCount"}
              label={"Çalışan Sayısı"}
              type="number"
              className="!m-0"
              inputClassName=" !p-2"
              placeholder={"Çalışan Sayısı"}
              rules={[{ required: true, message: "" }]}
            />

            <CountryAdressDetails
              size="large"
              selectInputType="inline"
              viewingFields={{
                country: false,
                stateProvince: true,
                district: true,
                city: false,
              }}
              fieldsRequiredRules={{
                country: false,
                stateProvince: true,
                district: true,
                city: false,
              }}
              form={form}
              allowClear={true}
            />

            <MazakaInput
              xs={24}
              name={"kepAddress"}
              label={"Açık Adres"}
              className="!m-0"
              inputClassName=" !p-2"
              placeholder={"Açık Adres"}
              rules={[{ required: true, message: "" }]}
            />

            <Col span={24} className="!flex gap-2">
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                disabled={isFindUser}
                processType={formActions.submitProcessType}
              >
                Kaydet
              </MazakaButton>
              {storeId && (
                <>
                  <MazakaButton
                    className="!p-4 !bg-black !text-white"
                    htmlType="submit"
                    onClick={() => {
                      props.setCurrentStep(3);
                      dispatch(handleSetDoneSteps({ data: [0, 1, 2] }));
                    }}
                  >
                    Devam Et
                  </MazakaButton>
                </>
              )}
            </Col>
          </Row>
        </MazakaForm>
      </Col>
      <Modal
        open={isShowConfirmCode}
        onCancel={() => {
          setIsShowConfirmCode(false);
        }}
        footer={false}
        title={false}
      >
        <ConfirmLoginCode
          setIsShowConfirmCode={setIsShowConfirmCode}
          numberPrefix={form.getFieldValue("Phone")?.split("+")[0] || ""}
          numberBody={form.getFieldValue("Phone")?.split("+")[1] || ""}
          onFinish={handleAfterConfirmPhone}
          email={email}
          isInstitutional={true}
        />
      </Modal>
    </>
  );
};

export default CorporateInfoes;
